import React, { Component, useState } from "react";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import Httpconfig from "../helpers/HttpconfigDiagnostics";
import Constant from "../../constants";
import { FormattedMessage, IntlProvider } from "react-intl"; // Backup Way to Convert
import { I18nPropvider, LOCALES } from "../../i18nProvider";
import translate from "../../i18nProvider/translate";
import RetailerCss from "../../public/css/retailer/retailer_style.css";
import DiagnosisHeader from "../diagnostics/DiagnosisHeader";
import DiagnosisMenu from "../diagnostics/DiagnosisMenu";
import Footer from "../patient/Patientfooter";
import { reactLocalStorage } from "reactjs-localstorage";
import dateformatter from "../helpers/dateformatter";
import * as SecureLS from "secure-ls";
var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});
const moment = require("moment");

export default class Diagnosistransactionhistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      errors: {},
      startDate: "",
      endDate: "",
    };
  }

  // To get detais after first render

  componentDidMount = () => {
    let userData = ls.get("diagnosticsuserObj");
    if (userData) {
      if (userData != "") {
        this.setState({
          retailerId: userData.diagnosis_id,
          retailerCurrency: userData.currency,
        });
      }
    } else {
      window.location.href = "/login";
    }
    this.retailerOrderDetails(userData.diagnosis_id, "5");
  };

  // Clear selected dates and reload initial orders
  clearDates = () => {
    try {
      $("#start_date").val("");
      $("#end_date").val("");
    } catch (e) {}

    this.setState({ startDate: "", endDate: "" }, () => {
      const status = this.state.fields["order_status"]
        ? this.state.fields["order_status"]
        : "5";
      this.retailerOrderDetails(this.state.retailerId, status);
    });
  };

  handleChange = (event) => {
    let fields = this.state.fields;
    fields["order_status"] = event.target.value;
    this.retailerOrderDetails(this.state.retailerId, fields["order_status"]);
  };

  // order details list

  retailerOrderDetails = (retailerId, status) => {
    let startDate = "";
    let endDate = "";
    let finalorderarray = [];
    let totalCost = 0;

    startDate = this.state.startDate;
    endDate = this.state.endDate;

    Httpconfig.httptokenpost(
      Constant.siteurl + "api/DIAGNOSIS/orderProcess/retailerOrdersSearch",
      {
        retailer_id: retailerId,
        start_date: startDate,
        end_date: endDate,
        status: status,
      }
    )
      .then((response) => {
        if (response.data.status == 200) {
          if (
            Array.isArray(response.data.data) &&
            response.data.data.length > 0
          ) {
            const retailerFinalOrderMedicineDetailsView = response.data.data.map(
              (finalLoadedData, num) => {
                if (
                  finalLoadedData.total_paid != null &&
                  finalLoadedData.total_paid != "NaN"
                ) {
                  totalCost =
                    parseFloat(totalCost) +
                    parseFloat(finalLoadedData.total_paid.replace(/,/g, ""));
                }
                return (
                  <tr>
                    <td>{num + 1}</td>
                    <td>
                      {console.log("num----", num)}
                      {finalLoadedData.patient_tbl
                        ? finalLoadedData.patient_tbl.name
                            .charAt(0)
                            .toUpperCase() +
                          finalLoadedData.patient_tbl.name.slice(1)
                        : " "}
                      <h6>
                        {finalLoadedData.patient_tbl
                          ? finalLoadedData.patient_tbl.phone_number
                          : ""}
                      </h6>
                    </td>
                    <td>{finalLoadedData.id}</td>
                    <td>
                      {dateformatter.asianDateFormat(
                        finalLoadedData.order_date
                      )}
                    </td>

                    <td class="presc_field">
                      {finalLoadedData.diagnostic_cart_prescriptions_tbls &&
                      finalLoadedData.diagnostic_cart_prescriptions_tbls
                        .length > 0 &&
                      finalLoadedData.diagnostic_cart_prescriptions_tbls[0]
                        .medical_document
                        ? finalLoadedData.diagnostic_cart_prescriptions_tbls[0].medical_document.map(
                            (presImages, num) => {
                              return (
                                <a
                                  key={num}
                                  href={presImages ? presImages : ""}
                                  target="_blank"
                                >
                                  <img
                                    class="presc_img"
                                    src="../images/retailer/Invoice.svg"
                                  />
                                </a>
                              );
                            }
                          )
                        : "--"}
                    </td>
                    <td>
                      {
                        Object.keys(
                          finalLoadedData.diagnostic_order_processing_tbls
                        ).length
                      }
                    </td>

                    <td>
                      {finalLoadedData.total_paid != null
                        ? this.state.retailerCurrency
                        : ""}{" "}
                      {finalLoadedData.total_paid != null
                        ? finalLoadedData.total_paid
                        : "--"}
                    </td>
                    <td>
                      {finalLoadedData.invoice ? (
                        <a
                          href={
                            finalLoadedData.invoice
                              ? finalLoadedData.invoice
                              : ""
                          }
                          target="_blank"
                        >
                          <img
                            class="presc_img"
                            src="../images/retailer/RxFile.svg"
                          />
                        </a>
                      ) : (
                        "--"
                      )}
                    </td>
                    <td>
                      {finalLoadedData.order_status == 5 ? (
                        <p class="text-success">Completed</p>
                      ) : finalLoadedData.order_status == 6 ? (
                        <p class="text-danger">Cancelled</p>
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                );
              }
            );
            console.log(
              "-------175-----",
              retailerFinalOrderMedicineDetailsView
            );
            this.setState({
              retailerFinalOrderMedicineDetailsView: retailerFinalOrderMedicineDetailsView,
              finalorderarray: finalorderarray,
              totalCost: totalCost,
            });
          } else {
            this.setState({
              retailerFinalOrderMedicineDetailsView: "",
            });
          }
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  //start date selection

  startDate = (event) => {
    let startDate = event.target.value;
    this.setState({
      startDate: moment(startDate).format("YYYY-MM-DD"),
    });
  };

  //  end date selection
  endDate = (event) => {
    let endDate = event.target.value;
    this.setState({
      endDate: moment(endDate).format("YYYY-MM-DD"),
    });
  };

  //  For showing order by date
  showOrderbyDates = () => {
    let start_date = $("#start_date").val();
    let end_date = $("#end_date").val();
    if (start_date <= end_date) {
      if (start_date != "" && end_date != "") {
        this.retailerOrderDetails(this.state.retailerId, 5);
      } else {
        toast.error("Please select dates");
      }
    } else {
      toast.error("from date cannot be greater than to date");
    }
  };

  render() {
    return (
      <main id="main">
        <DiagnosisHeader />
        <DiagnosisMenu />
        <section id="Pharmacy_dashboard">
          <div class="col-lg-10 col-md-10 Pharma_Content">
            <section class="retailer_section">
              <div class="container-fluid">
                <div class="row col-md-12 trans_history">
                  <div class="col-lg-8 col-md-12 p_schedule no_padding">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        gap: "12px",
                        flexWrap: "wrap",
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <label>Select Date</label>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <input
                            type="date"
                            id="start_date"
                            class="form-control"
                            placeholder="yyyy-mm-dd"
                            onChange={this.startDate}
                            max={moment().format("YYYY-MM-DD")}
                          />
                          <span style={{ whiteSpace: "nowrap" }}>To</span>
                          <input
                            type="date"
                            id="end_date"
                            class="form-control"
                            onChange={this.endDate}
                            max={moment().format("YYYY-MM-DD")}
                          />
                        </div>
                      </div>

                      <div
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          marginLeft: "6px",
                          background: "#ffffff 0% 0% no-repeat padding-box",
                          border: "1px solid #00B7CE",
                          borderRadius: "6px",
                          opacity: 1,
                          height: "35px",
                          justifyContent: "center",
                          padding: "0 20px",
                          cursor: "pointer",
                        }}
                        onClick={this.showOrderbyDates}
                      >
                        <span>find</span>
                      </div>

                      <div
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          marginLeft: "6px",
                          background: "#ffffff 0% 0% no-repeat padding-box",
                          border: "1px solid #00B7CE",
                          borderRadius: "6px",
                          opacity: 1,
                          height: "35px",
                          justifyContent: "center",
                          padding: "0 20px",
                          cursor: "pointer",
                        }}
                        onClick={this.clearDates}
                      >
                        <span>Clear</span>
                      </div>

                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <label style={{ whiteSpace: "nowrap" }}>
                          Order Status
                        </label>
                        <select
                          name="order_status"
                          class="form-control"
                          value={this.state.fields["order_status"]}
                          onChange={this.handleChange.bind(this)}
                        >
                          <option value="5">Completed</option>
                          <option value="6">Cancelled</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-4 col-md-12 no_padding">
                    <nav class="p_nav">
                      <div
                        class="nav nav-tabs nav-fill"
                        id="nav-tab"
                        role="tablist"
                      >
                        <a
                          class="nav-item nav-link active"
                          id="online-tab"
                          data-toggle="tab"
                          href="#online_home"
                          role="tab"
                          aria-controls="online_home"
                          aria-selected="true"
                        >
                          Total Amount
                          <p>
                            {Constant.currency}{" "}
                            {this.state.totalCost
                              ? parseFloat(this.state.totalCost)
                                  .toFixed(2)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                              : "0.00"}
                          </p>
                        </a>
                      </div>
                    </nav>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="tab-content tab_side" id="nav-tabContent">
                      <div
                        class="tab-pane fade show active"
                        id="online_home"
                        role="tabpanel"
                        aria-labelledby="online-tab"
                      >
                        <div class="container-fluid">
                          <div class="row">
                            <div class="col-md-12 no_padding">
                              <div class="tableFixHead">
                                <table>
                                  <thead>
                                    <tr>
                                      <th>No</th>
                                      <th>Customer</th>
                                      <th>Order ID</th>
                                      <th>Order Date</th>
                                      <th>Prescription</th>
                                      <th>Items</th>
                                      <th>Invoice Amount</th>
                                      <th>Invoice</th>
                                      <th>Order Status</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state
                                      .retailerFinalOrderMedicineDetailsView ? (
                                      this.state
                                        .retailerFinalOrderMedicineDetailsView
                                    ) : (
                                      <React.Fragment>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>No Order Found</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>{" "}
                                      </React.Fragment>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <ToastContainer />
          </div>
        </section>
      </main>
    );
  }
}
